<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);
const body = field<string>("body", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:letter-text" accent="content">
    <EditorMarkdownDrawerField
      v-model="body"
      :title="t('editTitle')"
      :description="t('editDescription')"
      :button-label="t('openEditor')"
      :empty-preview="t('empty')"
    />
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Markdown"
  openEditor: "Edit content…"
  editTitle: "Edit Markdown"
  editDescription: "Update your markdown content below, then apply your changes."
  empty: "No markdown content yet."
</i18n>
